import { FC } from 'react';

import { ButtonList } from '@rikstv/play-common/src/components/button';
import { LinkButton } from '@rikstv/play-common/src/components/linkButton/LinkButton';
import { DisplayTitle } from '@rikstv/shared-components';

import { urlFor } from '../../../../apis/sanity-image.utils';
import { StrimStartPageResponse } from '../../../../apis/sanityClient';
import { PortableTextToRDS } from '../../../../common/components/sanityComponents/blockContent';

import styles from './Hero.module.css';

export const Hero: FC<{ data: StrimStartPageResponse }> = ({ data }) => {
  if (!data.heroImageUrl || !data.title || !data.ingress) {
    return null;
  }

  const primaryButton = data.primaryCTA;
  const secondaryButton = data.secondaryCTA;
  const heroImageUrl = data.heroImageUrl;

  return (
    <div className={styles.hero}>
      <div className={styles.images}>
        {heroImageUrl && (
          <picture className={styles.pix}>
            <img src={urlFor(heroImageUrl).width(768).auto('format').url()} alt={'Strim forsidebilde'} />
          </picture>
        )}
      </div>
      <div className={styles.header}>
        <DisplayTitle>{data.title}</DisplayTitle>
        <PortableTextToRDS content={data.ingress} />

        <ButtonList>
          {primaryButton && (
            <LinkButton withArrow buttonStyle="primary" to={primaryButton.link} data-testid="primary-cta-button">
              {primaryButton.text}
            </LinkButton>
          )}
          {secondaryButton && (
            <LinkButton
              buttonStyle="highlighted"
              withArrow
              to={secondaryButton.link}
              data-testid="secondary-cta-button">
              {secondaryButton.text}
            </LinkButton>
          )}
        </ButtonList>
      </div>
    </div>
  );
};
